import { Navigate } from "react-router-dom";
import {
  clearAuth,
  hasValidSession,
  markSessionExpired,
} from "../services/authService";

const PrivateRoute = ({ children }) => {
  if (!hasValidSession()) {
    clearAuth();
    markSessionExpired();
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;